/* =============================================================================
 * Delta Clothing — B2B config (single source of truth)
 *
 * Reads the logged-in customer id from <body customer="..."> and exposes the
 * Dash API base URL plus a small set of helpers every other b2b-* bundle
 * leans on.
 *
 * Loaded first (defer) in layout/theme.liquid so b2b-cart-store.js etc. can
 * rely on `window.B2B` being defined.
 * =============================================================================*/
(function () {
  if (window.B2B) return;

  var DASH_BASE = 'https://dash.deltaclothing.com';

  function getCustomerId() {
    try {
      var raw = document.body && document.body.getAttribute('customer');
      return raw ? String(raw).trim() : '';
    } catch (e) { return ''; }
  }

  function getCustomerGid() {
    var id = getCustomerId();
    return id ? ('gid://shopify/Customer/' + id) : '';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {}),
      cache: 'no-store'
    }).then(function (r) {
      return r.json().catch(function () { return null; });
    });
  }

  function get(url) {
    return fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (data) {
          return { status: r.status, ok: r.ok, data: data };
        });
      });
  }

  var _cid = getCustomerId();

  window.B2B = {
    DASH_BASE: DASH_BASE,
    PAYMENT_FEE_RATE: 0.035,
    // Brand review #3 (#7): exposed so b2b-card-price.js (and any future
    // module) can short-circuit on the anonymous-visitor path with one
    // truthy check instead of repeating the body-attribute parse.
    customer: { id: _cid, gid: _cid ? ('gid://shopify/Customer/' + _cid) : '' },
    endpoints: {
      bag:           DASH_BASE + '/bag',
      bagCount:      DASH_BASE + '/bag_count',
      coupon:        DASH_BASE + '/coupon',
      remove:        DASH_BASE + '/remove',
      clear:         DASH_BASE + '/clear',
      payment:       DASH_BASE + '/payment',
      stock:         DASH_BASE + '/stock',
      depot:         DASH_BASE + '/shopify_products_depot_0',
      // Brand review #3 (#7): live since delta-clothing-new commit
      // 8c9ee6b (ThemeApiController::cardsPrices). Painter falls back
      // silently if the route ever 404s in the future.
      cardsPrices:   DASH_BASE + '/api/cards/prices',
      customerLimits: function (cid) { return DASH_BASE + '/api/customer-limits/' + encodeURIComponent(cid); }
    },
    getCustomerId: getCustomerId,
    getCustomerGid: getCustomerGid,
    postJSON: postJSON,
    get: get
  };

  // Pre-connect to Dash so the first cart fetch isn't a cold TLS handshake.
  try {
    var hints = '<link rel="dns-prefetch" href="' + DASH_BASE + '">' +
                '<link rel="preconnect" href="' + DASH_BASE + '" crossorigin>';
    document.head.insertAdjacentHTML('beforeend', hints);
  } catch (e) {}
})();
